export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS'
export const FETCH_PAYMENTS_SUCCESS = 'FETCH_PAYMENTS_SUCCESS'
export const SET_INVOICE_TO_EDIT = 'INVOICE_TO_EDIT'
export const REMOVE_INVOICE = 'REMOVE_INVOICE'
export const FETCH_UNPAID_ONE_TIME_INVOICE_SUCCESS = 'FETCH_UNPAID_ONE_TIME_INVOICE_SUCCESS'
export const FETCH_UNPAID_UPSELL_INVOICES_SUCCESS = 'FETCH_UNPAID_UPSELL_INVOICES_SUCCESS'
